import { render, staticRenderFns } from "./splide.vue?vue&type=template&id=5c907eea&scoped=true&"
import script from "./splide.vue?vue&type=script&lang=js&"
export * from "./splide.vue?vue&type=script&lang=js&"
import style0 from "./splide.vue?vue&type=style&index=0&id=5c907eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c907eea",
  null
  
)

export default component.exports